<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px">
        <div class="flex jcSb aiCt">
          <div>
            <a-button type="default" @click="$router.push('/analysis/majorList')">返回专业列表</a-button>
          </div>
        </div>
      </div>

      <a-table
        :columns="columns"
        :data-source="provinceRows"
        :rowKey="'name'"
        :pagination="false"
      >
        <template slot="status" slot-scope="text, record">
          <a-tag :color="record.configured ? 'green' : 'orange'">{{ record.configured ? '已设置' : '未设置' }}</a-tag>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="openEdit(record)">编辑</a>
        </template>
      </a-table>
    </div>

    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      width="800px"
    >
      <a-form-model 
        ref="ruleForm" 
        :model="form" 
        :rules="rules" 
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="省份" prop="province_name">
          <a-input v-model="form.province_name" disabled />
        </a-form-model-item>

        <a-divider>考试日期（选择周六/周日对应日期）</a-divider>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="一月周六" prop="jan_sat">
              <a-date-picker v-model="form.jan_sat" format="YYYY-MM-DD" style="width:100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="一月周日" prop="jan_sun">
              <a-date-picker v-model="form.jan_sun" format="YYYY-MM-DD" style="width:100%" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="四月周六" prop="apr_sat">
              <a-date-picker v-model="form.apr_sat" format="YYYY-MM-DD" style="width:100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="四月周日" prop="apr_sun">
              <a-date-picker v-model="form.apr_sun" format="YYYY-MM-DD" style="width:100%" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="七月周六" prop="jul_sat">
              <a-date-picker v-model="form.jul_sat" format="YYYY-MM-DD" style="width:100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="七月周日" prop="jul_sun">
              <a-date-picker v-model="form.jul_sun" format="YYYY-MM-DD" style="width:100%" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="十月周六" prop="oct_sat">
              <a-date-picker v-model="form.oct_sat" format="YYYY-MM-DD" style="width:100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="十月周日" prop="oct_sun">
              <a-date-picker v-model="form.oct_sun" format="YYYY-MM-DD" style="width:100%" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-divider>报告网址</a-divider>
        <a-form-model-item label="报名URL" prop="report_url">
          <a-input v-model="form.report_url" placeholder="请输入报名网址" />
        </a-form-model-item>

      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { getProvincePolicyList, saveProvincePolicy } from '@/libs/analysis'

const DEFAULT_PROVINCES = [
  '北京市','上海市','天津市','重庆市','河北省','山西省','辽宁省','吉林省','黑龙江省','江苏省','浙江省','安徽省','福建省','江西省','山东省','河南省','湖北省','湖南省','广东省','广西壮族自治区','海南省','四川省','贵州省','云南省','西藏自治区','陕西省','甘肃省','青海省','宁夏回族自治区','新疆维吾尔自治区','内蒙古自治区'
]

export default {
  name: 'provincePolicy',
  data() {
    return {
      columns: [
        { title: '省份', dataIndex: 'name', key: 'name' },
        { title: '状态', key: 'status', scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } },
      ],
      provinceRows: [],
      visible: false,
      confirmLoading: false,
      modalTitle: '编辑省份政策',
      form: {
        id: null,
        province_name: '',
        jan_sat: null,
        jan_sun: null,
        apr_sat: null,
        apr_sun: null,
        jul_sat: null,
        jul_sun: null,
        oct_sat: null,
        oct_sun: null,
        report_url: '',
        policy_html: ''
      },
      rules: {
        province_name: [{ required: true, message: '请选择省份', trigger: 'change' }],
      },
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    async loadList() {
      try {
        const list = await getProvincePolicyList({})
        if (Array.isArray(list)) {
          const map = {}
          list.forEach(item => { map[item.province_name] = item })
          this.provinceRows = DEFAULT_PROVINCES.map(name => ({
            name,
            configured: !!map[name],
            config: map[name] || null,
          }))
        } else {
          this.provinceRows = DEFAULT_PROVINCES.map(name => ({ name, configured: false }))
        }
      } catch (e) {
        // 后端未就绪时使用默认省份列表
        this.provinceRows = DEFAULT_PROVINCES.map(name => ({ name, configured: false }))
      }
    },
    openEdit(record) {
      this.modalTitle = `编辑「${record.name}」政策`
      const cfg = record.config || {}
      this.form = {
        id: cfg.id || null,
        province_name: record.name,
        jan_sat: cfg.jan_sat ? moment(cfg.jan_sat) : null,
        jan_sun: cfg.jan_sun ? moment(cfg.jan_sun) : null,
        apr_sat: cfg.apr_sat ? moment(cfg.apr_sat) : null,
        apr_sun: cfg.apr_sun ? moment(cfg.apr_sun) : null,
        jul_sat: cfg.jul_sat ? moment(cfg.jul_sat) : null,
        jul_sun: cfg.jul_sun ? moment(cfg.jul_sun) : null,
        oct_sat: cfg.oct_sat ? moment(cfg.oct_sat) : null,
        oct_sun: cfg.oct_sun ? moment(cfg.oct_sun) : null,
        report_url: cfg.report_url || '',
        policy_html: cfg.policy_html || ''
      }
      this.visible = true
    },
    async handleOk() {
      this.$refs.ruleForm && this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        this.confirmLoading = true
        const payload = {
          id: this.form.id,
          province_name: this.form.province_name,
          jan_sat: this.form.jan_sat ? this.form.jan_sat.format('YYYY-MM-DD') : '',
          jan_sun: this.form.jan_sun ? this.form.jan_sun.format('YYYY-MM-DD') : '',
          apr_sat: this.form.apr_sat ? this.form.apr_sat.format('YYYY-MM-DD') : '',
          apr_sun: this.form.apr_sun ? this.form.apr_sun.format('YYYY-MM-DD') : '',
          jul_sat: this.form.jul_sat ? this.form.jul_sat.format('YYYY-MM-DD') : '',
          jul_sun: this.form.jul_sun ? this.form.jul_sun.format('YYYY-MM-DD') : '',
          oct_sat: this.form.oct_sat ? this.form.oct_sat.format('YYYY-MM-DD') : '',
          oct_sun: this.form.oct_sun ? this.form.oct_sun.format('YYYY-MM-DD') : '',
          report_url: this.form.report_url,
          policy_html: this.form.policy_html,
        }
        try {
          const result = await saveProvincePolicy(payload)
          console.log(result)
          // 请求封装会在 code==1 时返回 data，本页以是否有返回来判断成功
          if (typeof result !== 'undefined') {
            this.$message.success('保存成功')
            this.visible = false
            this.loadList()
          } else {
            this.$message.error('保存失败')
          }
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.confirmLoading = false
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
</style>